<template>
  <v-toolbar dark color="primary">
    <v-btn icon @click="close">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <v-toolbar-title>
      {{ title }}
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-toolbar-items>
      <slot name="extraButtons"></slot>
      <v-btn
        v-show="showBtn"
        text
        :disabled="btnDisabled"
        @click="$emit('btnClicked')"
      >
        {{ btnTitle }}
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: "Modal Title"
    },
    btnTitle: {
      type: String,
      default: "Button Text"
    },
    btnDisabled: {
      type: Boolean,
      default: false
    },
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapActions(["reset"]),
    close(){
      this.$emit('close');
      this.reset()
    }
  }
};
</script>

<style></style>
